import _ from 'lodash';
import {ProductInCatalog} from '@treez/commons/sharedTypings/product';
import {HighLightProductAction} from '../actions/HighlightedProductActions';

export interface HighlightedProductsState {
    highlightedProducts: ProductInCatalog[];
}

const {HIGHLIGHT_PRODUCT, HIGHLIGHT_MULTIPLE_PRODUCTS, CLEAR_HIGHLIGHTED_PRODUCTS} =
    HighLightProductAction;

const DEFAULT_HIGHLIGHT_STATE = {
    highlightedProducts: [],
};

export const HighlightedProductsReducer = (state = DEFAULT_HIGHLIGHT_STATE, action: any) => {
    const {type: typeOfAction, value} = action;

    const highlighedProductIds = _.map(state.highlightedProducts, 'id');

    switch (typeOfAction) {
        case HIGHLIGHT_MULTIPLE_PRODUCTS:
            const valuesFiltered = _.filter(value, (product) => {
                return !_.includes(highlighedProductIds, product.id);
            });

            return {
                ...state,
                highlightedProducts: [...state.highlightedProducts, ...valuesFiltered],
            };
        case HIGHLIGHT_PRODUCT:
            const highlightedProductWithoutNewValue = _.filter(
                state.highlightedProducts,
                (product) => {
                    return _.get(product, 'id') !== value.id;
                }
            );

            return {
                ...state,
                highlightedProducts: [...highlightedProductWithoutNewValue, value],
            };
        case CLEAR_HIGHLIGHTED_PRODUCTS:
            return DEFAULT_HIGHLIGHT_STATE;
        default:
            return state;
    }
};

export default HighlightedProductsReducer;
